import translator from '@/locales';

export function transformPageOptions({
  perPage,
  currentPage,
  selectedKeywordsCount,
}) {
  if (currentPage === 1) {
    return {
      offset: 1,
      limit: perPage - selectedKeywordsCount,
    };
  }
  return {
    offset: (currentPage - 1) * perPage - selectedKeywordsCount,
    limit: perPage,
  };
}

export function transformDataToTableData({
  startingQueries,
  suggestedQueries,
  currentPage,
}) {
  const transformedData = [];
  if (startingQueries.length && currentPage == 1) {
    transformedData.push({
      title: translator.t(
        'ADVERTISEMENT.KEYWORDPLANNER.SELECTED_KEYWORDS_ROW_HEADING',
      ),
      data: startingQueries,
    });
  }
  if (suggestedQueries.length) {
    transformedData.push({
      title: translator.t(
        'ADVERTISEMENT.KEYWORDPLANNER.SUGGESTED_KEYWORDS_ROW_HEADING',
      ),
      data: suggestedQueries,
    });
  }
  return transformedData;
}
